import { gql } from "@apollo/client";

export type GetVenuePortalUserNotificationsInput = {
  venuePortalUserId: string;
  iso639_1: string;
};

export type GetVenuePortalUserNotificationsResponse = {
  venuePortalUser: {
    id: string;
    notificationLinks: {
      venuePortalUserId: string;
      venuePortalNotificationId: string;
      readAt: string | null;
      notification: {
        id: string;
        created: string;
        updatedAt: string;
        translation: {
          id: string;
          iso639_1: string;
          body: string;
          subject: string;
        } | null;
      };
    }[];
  };
};

export const GET_VENUE_PORTAL_USER_NOTIFICATIONS_QUERY = gql`
  query GetVenuePortalUserNotifications(
    $venuePortalUserId: ID
    $iso639_1: String!
  ) {
    venuePortalUser(id: $venuePortalUserId) {
      id
      notificationLinks {
        venuePortalUserId
        venuePortalNotificationId
        readAt
        notification {
          id
          created
          updatedAt
          translation(iso639_1: $iso639_1) {
            id
            iso639_1
            body
            subject
          }
        }
      }
    }
  }
`;
